<template>
  <article class="page-statistics-dep2per">
    <!-- chart panel -->
    <crm-panel class="chart-panel">
      <!-- total time -->
      <section class="tips-container">
        <span class="tips-container_text">数据统计于{{ totalTime }}</span>
      </section>
      <!-- toolbar -->
      <section class="select-container">
        <el-form :inline="true">
          <span class="select-container_label">销售业绩统计</span>
          <el-form-item>
            <el-date-picker
              v-model="selectYear"
              type="year"
              placeholder="选择年"
              @change="handleSearch"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <crm-cascader
              :value="tableSearchForm.teamId"
              :options="statisticsTeamList"
              placeholder="团队"
              @change="changeParentTeam"
            >
            </crm-cascader>
          </el-form-item>
        </el-form>
        <div class="select-container_buttons">
          <crm-button
            v-if="
              auth.kbSalesPerformanceExport &&
              auth.kbSalesPerformanceExport.toggleStatus
            "
            buttonType="plain"
            text="导出"
            @click="handleExport()"
          >
          </crm-button>
        </div>
      </section>
      <!-- total block -->
      <section class="total-container">
        <div
          class="total-container_block"
          v-for="totalBlock in totalBlockList"
          :key="totalBlock.tipText"
        >
          <crm-block v-bind="totalBlock" />
        </div>
      </section>
      <!-- chart -->
      <section class="chart-container" />
    </crm-panel>

    <!-- table panel -->
    <crm-panel class="table-panel">
      <!-- table -->
      <el-table
        :data="tableData"
        border
        v-loading="loading"
        height="100%"
        style="width: 100%"
      >
        <el-table-column fixed prop="monthDate" label="月份" align="center">
          <template slot-scope="scope">
            <span>{{ month[scope.row.monthDate] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed
          prop="signingAmountStr"
          label="合同金额(万元)"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.signingAmountStr | conversion }}</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed
          prop="refundAmountStr"
          label="回款(万元)"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.refundAmountStr | conversion }}</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed
          prop="grossProfitStr"
          label="毛利(万元)"
          align="center"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.grossProfitStr | conversion }}</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- pageination -->
      <!-- <div class="pageination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="tableSearchForm.pageNumber"
          :page-sizes="[10, 20, 50]"
          :page-size="tableSearchForm.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="tableData.totalCount">
        </el-pagination>
      </div> -->
    </crm-panel>
  </article>
</template>

<script>
import moment from 'moment';
import * as echarts from 'echarts/echarts.common';
import { mapActions, mapGetters } from 'vuex';
import { performanceCount } from 'crm-common';

import { conversion, downloadByUrl } from '@/scripts/utils';
import http from '~services/axios';
import CHART_TOTAL_BLOCK_PROPS from '~services/constant/statistics/performance-total-block';
import CHART_API_CONFIG from '~api/statistics/performance-api-config';
import getTimeRangeByAlias from '~services/time-range';

import ChartTotalTimeOptions from '@/components/business/datastatistics/chart-total-time-options';
import CrmPanel from '@/components/base/crmPanel';
import CrmButton from '@/components/base/crmButton';
import CrmBlock from '@/components/base/crmBlock';
import CrmCascader from '@/components/base/crmCascader';

const {
  apiFactory,
  totalFactory,
  chartFactory: optionFactory,
} = performanceCount;
const diagramCommonApi = apiFactory(http, CHART_API_CONFIG);

// crm-common包中对每个图表定义的名称
const CHART_NAME = 'salesPerformance';

/**
 * TABLE_GETTER_NAME: vuex-store里对应的表格数据getter名称
 * TABLE_ACTION_NAME: vuex-store里对应的表格数据获取action名称
 *  */
const TABLE_GETTER_NAME = 'salesmanTableData';
const TABLE_ACTION_NAME = 'getSalesmanTableData';

// echarts instance
let chart;
const echartsConfig = {
  devicePixelRatio: window.devicePixelRatio,
};
const defaultDataFormat = 'YYYY-MM-DD HH:mm:ss';

export default {
  components: {
    CrmPanel,
    CrmButton,
    CrmBlock,
    ChartTotalTimeOptions,
    CrmCascader,
  },
  filters: {
    conversion,
  },
  data() {
    const chartSearchForm = {
      startTimeStr: moment()
        .startOf('Y')
        .format(defaultDataFormat),
      endTimeStr: moment().format(defaultDataFormat),
    };

    return {
      loading: false,
      totalTime: moment().format(defaultDataFormat),
      selectYear: moment().startOf('Y'),
      totalBlockList: [],
      tableData: [],
      month: {
        '01': '1月',
        '02': '2月',
        '03': '3月',
        '04': '4月',
        '05': '5月',
        '06': '6月',
        '07': '7月',
        '08': '8月',
        '09': '9月',
        10: '10月',
        11: '11月',
        12: '12月',
      },
      chartSearchForm,
      tableSearchForm: {
        ...chartSearchForm,
        // isAgencyTeam: 3,
      },
    };
  },
  computed: {
    ...mapGetters({
      auth: 'authority/auth',
      userInfo: 'authority/userInfo',
      statisticsTeamList: 'statistics/statisticsTeamList',
    }),
  },
  mounted() {
    const chartContaiter = document.querySelector('.chart-container');
    chart = echarts.init(chartContaiter, 'light', echartsConfig);

    this.getStatiisticsTeamList().then(() => {
      if (this.statisticsTeamList.length > 0) {
        this.tableSearchForm.teamId = this.userInfo.teamId;
        this.chartSearchForm.teamId = this.userInfo.teamId;
      }
      this.getDiagram();
    });
  },
  methods: {
    ...mapActions({
      getStatiisticsTeamList: 'statistics/getStatiisticsTeamList',
    }),
    renderTotalTime() {
      this.totalTime = moment().format(defaultDataFormat);
    },
    handleSearch(value) {
      const endTime = moment(value).format('YYYY') !== moment().format('YYYY')
        ? moment(value)
          .endOf('Y')
          .format(defaultDataFormat)
        : moment().format(defaultDataFormat);
      this.tableSearchForm = {
        ...this.tableSearchForm,
        startTimeStr: moment(value)
          .startOf('Y')
          .format(defaultDataFormat),
        endTimeStr: endTime,
      };
      this.chartSearchForm = {
        ...this.chartSearchForm,
        startTimeStr: moment(value)
          .startOf('Y')
          .format(defaultDataFormat),
        endTimeStr: endTime,
      };
      this.getDiagram();
    },
    changeParentTeam(team) {
      this.tableSearchForm.teamId = team[team.length - 1];
      this.chartSearchForm.teamId = team[team.length - 1];
      this.getDiagram();
    },
    renderTotalBlock(data) {
      // total: [{ key: 'costAmountTotalStr', value: 0, name: '总成本' }, ...]
      const total = totalFactory(CHART_NAME, data);
      this.totalBlockList = total.map(({ key, value, name }) => {
        const totalComponentProps = CHART_TOTAL_BLOCK_PROPS[key];
        totalComponentProps.theme = value;
        return totalComponentProps;
      });
    },
    renderChart(data) {
      const option = optionFactory(CHART_NAME, data);
      chart.setOption(option);
    },
    // chart ajax
    getDiagram() {
      diagramCommonApi(CHART_NAME, this.chartSearchForm).then((res) => {
        const {
          data: { reportForm = [], reportFormTotal },
        } = res.data;
        // if (this.chartSearchForm.endTimeStr.split('')[0]
        // === moment().format(defaultDataFormat).split('')[0]) {
        // const month = moment().format(defaultDataFormat).split
        // reportForm = reportForm.filter(v => );
        // }
        this.tableData = reportForm;
        this.renderTotalTime();
        this.renderTotalBlock(reportFormTotal);
        this.renderChart(reportForm);
      });
    },
    handleExport() {
      const params = this.tableSearchForm;
      this.notify = this.$notify({
        iconClass: 'el-icon-loading',
        title: '',
        message: '正在导出中，请稍后...',
        duration: 0,
        showClose: false,
      });

      let url = '/api/datakanban/salesPerformanceExport?';
      Object.keys(params).forEach((item) => {
        if (params[item]) url += `${item}=${params[item]}&`;
      });

      downloadByUrl(url);
      if (this.notify) this.notify.close();
    },
  },
};
</script>

<style lang="less" scoped>
.page-statistics-dep2per {
  width: 100%;

  // 图表面板
  .chart-panel {
    padding: 0;
    .tips-container {
      background: rgba(240, 183, 98, 0.1);
      height: 28px;
      line-height: 28px;
      &_text {
        padding-left: 20px;
        color: #7a84b7;
      }
    }
    .select-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px;
      &_label {
        line-height: 42px;
        font-size: 24px;
        color: #7a84b7;
        padding-right: 30px;
      }
    }
    .total-container {
      display: flex;
      flex-wrap: wrap;
      &_block {
        margin-left: 20px;
        margin-bottom: 20px;
      }
    }
    .chart-container {
      margin: 0 20px 20px 20px;
      height: 220px;
    }
  }

  // 表格面板
  .table-panel {
    margin-top: 20px;
    height: 400px;
  }
}
</style>
